import React from "react";
import { X } from "react-bootstrap-icons";
import { FcGoogle } from "react-icons/fc";
import useOneTapAuth from "@/hooks/useOneTapAuth";
import { MIXPANEL_REGISTER_LOCATION_GOOGLE_ONE_TAP_MODAL } from "@/constants/mixpanel.constants";

interface OneTapSignInModalProps {
    show: boolean;
    onClose: () => void;
    redirectPath?: string;
    version?: string;
    location?: string;
}

/**
 * OneTapSignInModal – streamlined desktop sign-in modal (Google only, single Continue).
 */
const OneTapSignInModal: React.FC<OneTapSignInModalProps> = ({
    show,
    onClose,
    redirectPath = "/puzzle",
    version = "puzzle",
    location = MIXPANEL_REGISTER_LOCATION_GOOGLE_ONE_TAP_MODAL,
}) => {
    const { shouldShow, handleGoogle } = useOneTapAuth({ redirectPath, version, onClose, location });

    if (!show || !shouldShow) {
        return null;
    }

    return (
        <div className="tw-fixed tw-top-[5vh] tw-right-[19%] tw-translate-x-1/2 tw-bg-[#111111] tw-rounded-2xl tw-shadow-2xl tw-transition-all tw-duration-300 tw-z-[100] tw-w-[350px] tw-max-w-[90vw]">
            <div className="tw-relative tw-px-5 tw-pt-3 tw-pb-6">
                <button
                    onClick={onClose}
                    className="tw-absolute tw-top-2 tw-right-4 tw-text-gray-400 hover:tw-text-gray-200 tw-transition-colors tw-bg-transparent tw-border-0 tw-p-1 tw-rounded-full"
                    aria-label="Close"
                >
                        <X className="tw-w-5 tw-h-5" />
                </button>

                <div className="tw-flex tw-items-center tw-gap-3 tw-mb-5">
                    <FcGoogle className="tw-w-[25px] tw-h-[25px] tw-shrink-0" />
                    <p
                        className="tw-m-0 tw-text-white"
                        style={{ fontSize: 16, fontWeight: 600, fontFamily: "Inter, sans-serif" }}
                    >
                        Sign in to PriceMe with Google
                    </p>
                </div>

                <button
                    onClick={handleGoogle}
                    className="tw-w-full tw-min-h-[44px] tw-h-11 tw-bg-[#2f80ff] tw-text-white tw-rounded-2xl hover:tw-opacity-90 tw-transition tw-flex tw-items-center tw-justify-center tw-text-sm tw-font-noto"
                >
                    Continue
                </button>
            </div>
        </div>
    );
};

export default OneTapSignInModal;
